/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCreatedBy } from './get-suspicious-transactions200-response-transaction-detail-list-inner-one-of-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors } from './get-suspicious-transactions200-response-transaction-detail-list-inner-one-of-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer } from './get-suspicious-transactions200-response-transaction-detail-list-inner-one-of-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUpdatedBy } from './get-suspicious-transactions200-response-transaction-detail-list-inner-one-of-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUploadedBy } from './get-suspicious-transactions200-response-transaction-detail-list-inner-one-of-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings } from './get-suspicious-transactions200-response-transaction-detail-list-inner-one-of-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'paymentType': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'electronicMethod': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'documentSize': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'legalValidity': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'invoiceIssuer': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'dpiError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'errors': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerErrors;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'warnings': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCreatedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'createdBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUpdatedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'updatedBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUploadedBy}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'uploadedBy': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerPaymentTypeEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerElectronicMethodEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDocumentSizeEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerLegalValidityEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDpiErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerDetectedDpiErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerCalculatedDpiErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerColorGradationErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerHeightMillisErrorEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfEvidenceListInnerWidthMillisErrorEnum];


